import { defineMessages } from 'react-intl';
import { defaultStylingSchema } from '../schema';

const messages = defineMessages({
  flagAlign: {
    id: 'Flag align',
    defaultMessage: 'Posicionamento da bandeira',
  },
  buttonText: {
    id: 'Button text',
    defaultMessage: 'Texto do botão',
  },
  hideButton: {
    id: 'Hide Button',
    defaultMessage: 'Ocultar botão',
  },
});

export const sliderBlockSchemaEnhancer = ({ formData, schema, intl }) => {
  // Apply default styling schema (themes, colors, etc.)
  defaultStylingSchema({ schema, formData, intl });

  // Add buttonText field to slides schema
  if (
    schema.properties?.slides?.schema?.fieldsets?.[0]?.fields &&
    schema.properties?.slides?.schema?.properties
  ) {
    schema.properties.slides.schema.fieldsets[0].fields.push('buttonText');
    schema.properties.slides.schema.properties.buttonText = {
      title: intl.formatMessage(messages.buttonText),
    };

    schema.properties.slides.schema.fieldsets[0].fields.push('hideButton');
    schema.properties.slides.schema.properties.hideButton = {
      title: intl.formatMessage(messages.hideButton),
      type: 'boolean',
    };

    // Add flagAlign field to slides schema
    schema.properties.slides.schema.fieldsets[0].fields.push('flagAlign');
    schema.properties.slides.schema.properties.flagAlign = {
      title: intl.formatMessage(messages.flagAlign),
      choices: [
        ['left', 'Esquerda'],
        ['center', 'Centro'],
        ['right', 'Direita'],
        ['bottom', 'Fundo'], // Nova opção para posicionar no fundo
      ],
      default: 'left',
    };
  }

  return schema;
};

// Keep the old function name for backward compatibility if needed
export const showcaseSchemaEnhancer = sliderBlockSchemaEnhancer;
